export default{
    name:'BussinessCenter',
    data(){
        return{
            imgs:[
                // {
                //     path:'home-img1.png',
                //     title:'标题1',
                // },
                // {
                //     path:'home-img2.png',
                //     title:'标题2',
                // },
                // {
                //     path:'home-img3.png',
                //     title:'标题3',
                // },
            ],
            cType:[],
            rType:[],
            companyType:'',
            companys:[],
            currentType:'',
            currentName:'',
            currentId:'',
        }
    },
    created(){
        this.getCompanytype();
        this.getRegion();
        this.getData();
        this.getRollPic();
    },
    methods:{
        getData(){
            var url='';
            var body={

            };
            if(this.currentType=='2'){
                url=this.api.getTldByCompanytype;
                body.code=this.currentId;
            }else{
                url=this.api.getTldCompanytype;
                body.regionId=this.currentId;
            }
            this.get(url,body).then(res=>{
                if(res.result==200){
                    this.companys=res.data;
                }
            }).catch();
        },
        getRollPic(){
            this.get(this.api.getRollPic,{topSize:6}).then(res=>{
                if(res.result==200){
                    this.imgs=res.data;
                }
            }).catch();
        },
        getCompanytype(){
            this.get(this.api.getCompanytype).then(res=>{
                if(res.result==200){
                    this.cType=res.data;
                }
            }).catch();
        },
        getRegion(){
            this.get(this.api.getRegion).then(res=>{
                if(res.result==200){
                    this.rType=res.data;
                }
            }).catch();
        },
        getTldByCompanytype(){
            var body={
                companytype:this.companyType,
            };
            this.get(this.api.getTldByCompanytype,body).then(res=>{
                if(res.result==200){
                    this.companys=res.data;
                }
                
            }
 
            ).catch();
        },
       
        getDetail(id){
            this.$router.push({path:'/companyDetail',query:{id:id}});
        },
        clickType(type,id){
            this.currentId=id;
            this.currentType=type;
            this.getData();
        },
    }
}